import { startMirage } from './mirage'

if (window.Cypress) {
  window.server = startMirage('test')
  window.server.logging = true
  window.runCypressMirageFunctions()
} else if (!!process.env.VUE_APP_INJECT_MOCKS) {
  window.server = startMirage()
}

import Labelbox from './labelbox'

if (!!process.env.VUE_APP_MOCK_LABELBOX) {
  window.Labelbox = Labelbox
  Labelbox.init(window.Cypress ? 1 : 500)
}
